import React from "react"
import PropTypes from "prop-types"

const VARIANTS = {
  pending: { stroke: "#B7B7B7", fill: "#B7B7B7", border: "#E9ECEF", bg: "white" },
  active: { stroke: "#22c55e", fill: "#22c55e", border: "#bbf7d0", bg: "#f0fdf4" },
}

export const CheckIn = ({ height = 25, width = 52, variant = "pending", ...props }) => {
  const colors = VARIANTS[variant] || VARIANTS.pending
  const uniqueId = variant
  return (
    <svg width={width} height={height} viewBox="0 0 52 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath={`url(#checkin-clip0-${uniqueId})`}>
        <mask id={`checkin-mask-${uniqueId}`} fill="white">
          <path d="M0 4C0 1.79086 1.79086 0 4 0H48C50.2091 0 52 1.79086 52 4V21C52 23.2091 50.2091 25 48 25H4C1.79086 25 0 23.2091 0 21V4Z" />
        </mask>
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H48C50.2091 0 52 1.79086 52 4V21C52 23.2091 50.2091 25 48 25H4C1.79086 25 0 23.2091 0 21V4Z"
          fill={colors.bg}
          fillOpacity="0.8"
        />
        <g clipPath={`url(#checkin-clip1-${uniqueId})`}>
          <path
            d="M22.6673 11.8867V12.5001C22.6665 13.9377 22.201 15.3365 21.3402 16.488C20.4794 17.6394 19.2695 18.4817 17.8909 18.8893C16.5123 19.297 15.0388 19.248 13.6903 18.7498C12.3418 18.2516 11.1904 17.3308 10.408 16.1248C9.6255 14.9188 9.25385 13.4921 9.34844 12.0576C9.44303 10.6231 9.99879 9.25762 10.9328 8.16479C11.8669 7.07195 13.1292 6.31033 14.5314 5.9935C15.9337 5.67668 17.4008 5.82163 18.714 6.40674"
            stroke={colors.stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.6667 7.1665L16 13.8398L14 11.8398"
            stroke={colors.stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path d="M27.26 17V8.6H28.46V17H27.26ZM30.9748 17V8.6H31.9588L37.5148 15.5H36.9988V8.6H38.1988V17H37.2148L31.6588 10.1H32.1748V17H30.9748Z" fill={colors.fill} />
      </g>
      <path
        d="M4 0V1.5H48V0V-1.5H4V0ZM52 4H50.5V21H52H53.5V4H52ZM48 25V23.5H4V25V26.5H48V25ZM0 21H1.5V4H0H-1.5V21H0ZM4 25V23.5C2.61929 23.5 1.5 22.3807 1.5 21H0H-1.5C-1.5 24.0376 0.962434 26.5 4 26.5V25ZM52 21H50.5C50.5 22.3807 49.3807 23.5 48 23.5V25V26.5C51.0376 26.5 53.5 24.0376 53.5 21H52ZM48 0V1.5C49.3807 1.5 50.5 2.61929 50.5 4H52H53.5C53.5 0.962434 51.0376 -1.5 48 -1.5V0ZM4 0V-1.5C0.962434 -1.5 -1.5 0.962435 -1.5 4H0H1.5C1.5 2.61929 2.61929 1.5 4 1.5V0Z"
        fill={colors.border}
        mask={`url(#checkin-mask-${uniqueId})`}
      />
      <defs>
        <clipPath id={`checkin-clip0-${uniqueId}`}>
          <path d="M0 4C0 1.79086 1.79086 0 4 0H48C50.2091 0 52 1.79086 52 4V21C52 23.2091 50.2091 25 48 25H4C1.79086 25 0 23.2091 0 21V4Z" fill="white" />
        </clipPath>
        <clipPath id={`checkin-clip1-${uniqueId}`}>
          <rect width="16" height="16" fill="white" transform="translate(8 4.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

CheckIn.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  variant: PropTypes.oneOf(["pending", "active"]),
}
